import $ from 'jquery';

function checkForInput(element) {
    const label = getClosestLabel(element);
    if ($(element).val().length > 0) {
        $(label).addClass('filled');
    } else {
        $(label).removeClass('filled');
    }
}

function getClosestLabel(element) {
    const parent = $(element).closest('li');
    return $(parent).find(' > label');
}

function labelAnimation() {
    $('.contact-form__form input').after('<div class="bar bottom"></div>');

    $('.contact-form__form input').each((index, el) => {
        checkForInput(el);
    });

    $('.contact-form__form input').on('focus', el => {
        const label = getClosestLabel(el.target);
        label.addClass('filling');
    });

    $('.contact-form__form input').on('focusout', el => {
        const label = getClosestLabel(el.target);
        label.removeClass('filling');
    });

    $('.contact-form__form input').on('change keyup', event => {
        checkForInput(event.currentTarget);
    });
}

$(document).on('gform_post_render', function (event, form_id, current_page) {
    labelAnimation();
});

labelAnimation();


